import { RequireSignedIn } from '@/components/auth/RequireSignedIn'
import { Header } from '@/components/common/header'
import { RequireOrganization } from '@/components/organization/RequireOrganization'
import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout')({
  component: StandardLayout,
})

function StandardLayout() {
  return (
    <RequireSignedIn>
      <RequireOrganization>
        <Header />
        <Outlet />
      </RequireOrganization>
    </RequireSignedIn>
  )
}
